<template>
  <form-wrapper
    title="Error Settings"
    :hint-images="hint"
  >
    <v-container grid-list-xs>

      <v-layout row wrap>
        <v-flex xs6 px-2 class="mb-5">
          <h4>White theme</h4>
          <color-settings
            title="Error message text color:"
            button-title="color"
            :color.sync="settings.whiteTheme.textColor"
          />
        </v-flex>
        <v-flex xs6 px-2>
          <h4>Dark theme</h4>
          <color-settings
            title="Error message text color:"
            button-title="color"
            :color.sync="settings.darkTheme.textColor"
          />
        </v-flex>
      </v-layout>
    </v-container>

    <reset-submit
      @submit="generateSubmit('error')"
      @reset="resetSettings"
    />

  </form-wrapper>
</template>

<script>
  import ColorSettings from './../styleSettingsFormComponents/ColorSettings'
  import FormWrapper from './FormWrapper'
  import ResetSubmit from './../styleSettingsFormComponents/ResetSubmit'
  import { submitGlobalStyles } from '@/utils/mixins'
  import {
    generateDefaultColor,
    generateMapState
  } from './utils'

  export default {
    name: 'ErrorSettings',
    components: {
      ColorSettings,
      FormWrapper,
      ResetSubmit
    },
    mixins: [submitGlobalStyles],
    data () {
      return {
        settings: {
          whiteTheme: {
            textColor: generateDefaultColor()
          },
          darkTheme: {
            textColor: generateDefaultColor()
          }
        },
        hint: [
          {url: '/static/info/error-dark.png', title: 'Dark theme' },
          {url: '/static/info/error-white.png', title: 'White theme ' },
        ]
      }
    },
    computed: {
      ...generateMapState('error')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/StylesSettings/styleForms/ErrorSettings.vue